export default "__VITE_ASSET__BYXQLIMp__"